import React, { useEffect, useState } from "react";
import HorizontalWorkflowStepper from "../../Components/Stepper";
import StepOneScreen from "./RFPSummary";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import StepTwoScreen from "./RfpCompleteness";
import StepThreeScreen from "./CarrierTransition";
import StepFourScreen from "./InfoConsolidation";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { UploadFile } from "@mui/icons-material";
import { getSession } from "../../Utils/Sessions";

const Evaluation = ({ ToHome, company, insuranceType }) => {
  const [activeStep, setActiveStep] = useState(1);

  // 🔹 Lifted state for Step 1
  const [rfpFile, setRfpFile] = useState(null);
  const [uploadCount, setUploadCount] = useState(0);
  const [additionalInfoSections, setAdditionalInfoSections] = useState([]);
  const [resummarizeCount, setResummarizeCount] = useState(0);
  const [apiResponse, setApiResponse] = useState();
  const [isLoading, setLoading] = useState(false);
  const [bookletFile, setBookletFile] = useState(null);
  const [CTApiResponse, setCTApiResponse] = useState();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [error, setError] = useState(false);

  const handleBookletUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setBookletFile(file);
    }
  };
  const NextStep = () => {
    setActiveStep((prev) => prev + 1);
  };

  const PrevStep = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleResummarize = () => {
    // can be used by StepOne to show updated summary messaging
    setResummarizeCount((prev) => prev + 1);
  };
  useEffect(() => {
    //API call here
    if (rfpFile) {
      analyzeDocument(rfpFile);
    }

    // if (insuranceType.includes("Dental")) {
    //   setApiResponse(uploadCount > 1 ? response2 : response);
    // } else {
    //   setApiResponse(uploadCount > 1 ? lifeResponse2 : lifeResponse);
    // }
  }, [rfpFile]);

  useEffect(() => {
    //API call here
    if (bookletFile) {
      translateDocument(bookletFile);
    }

    // if (insuranceType.includes("Dental")) {
    //   setCTApiResponse(carrierResponse);
    // } else {
    //   setCTApiResponse(carrierLifeResponse);
    // }
  }, [bookletFile]);

  const analyzeDocument = async (file) => {
    setError(false);
    setLoading(true);
    let payload;
    const reader = new FileReader();

    reader.onload = async () => {
      // Full data URL
      const dataUrl = reader.result;

      // Extract pure Base64 (no mime prefix)
      const base64 = dataUrl.split(",")[1];

      payload = {
        file_name: file.name,
        file_b64: base64,
      };
      try {
        const response = await fetch(BASE_URL + "pfg-bp-rfp-intake", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-file-name":file.name
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        // console.log(data);
        if (data.success) {
          setLoading(false);
          setApiResponse(data);
          setError(false);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
        console.log(err);
      }
    };

    reader.readAsDataURL(file);
  };

  // const translateDocument = async (file) => {
  //   setError(false);
  //   setLoading(true);
  //   let payload;
  //   const reader = new FileReader();

  //   reader.onload = async () => {
  //     // Full data URL
  //     const dataUrl = reader.result;

  //     // Extract pure Base64 (no mime prefix)
  //     const base64 = dataUrl.split(",")[1];

  //     payload = {
  //       file_name: file.name,
  //       contents: base64,
  //     };
  //     try {
  //       const response = await fetch(BASE_URL + "pfg-bp-carrier-translation", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       });

  //       const data = await response.json();

  //       if (data.success) {
  //         setLoading(false);
  //         setCTApiResponse(JSON.parse(data.answer));
  //         setError(false);
  //       } else {
  //         setError(true);
  //       }
  //     } catch (err) {
  //       setError(true);
  //       console.log(err);
  //     }
  //   };

  //   reader.readAsDataURL(file);
  // };

  const translateDocument = async (file) => {
    setError(false);
    setLoading(true);

    const reader = new FileReader();

    reader.onload = async () => {
      // Full data URL
      const dataUrl = reader.result;

      // Extract pure Base64 (no mime prefix)
      const contents_b64 = dataUrl.split(",")[1];
      let sessionId = getSession();
      const payload = {
        action: "extract",
        session_id: sessionId, // from AuthContext
        file_name: file.name, // FILE_NAME_IN_REQUEST
        contents: contents_b64, // contents_b64
        doc_version: "LATEST",
      };

      try {
        const response = await fetch(BASE_URL + "pfg-bp-carrier-translation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-file-name":file.name
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (data.success) {
          setLoading(false);
          setCTApiResponse(JSON.parse(data.answer));
          setError(false);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error(err);
        setError(true);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <>
      <HorizontalWorkflowStepper activeStep={activeStep} />
      <Box sx={{ mt: 15 }} />

      {activeStep > 1 && (
        <Card
          sx={{
            mb: 3,
            borderRadius: 3,
            justifySelf: "center",
            mx: 2,
            width: "95vw",
            maxWidth: 1500,
          }}
        >
          <CardContent>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent="space-between"
              spacing={2}
            >
              <Stack direction={"row"} spacing={2}>
                <ArrowBackIcon
                  sx={{ cursor: "pointer", mt: 0.5 }}
                  onClick={PrevStep}
                />
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {" "}
                  {company} #482
                </Typography>
              </Stack>

              {activeStep === 3 && (
                <>
                  <input
                    id="booklet-upload"
                    type="file"
                    accept=".pdf,.doc,.docx"
                    style={{ display: "none" }}
                    onChange={handleBookletUpload}
                  />
                  <label htmlFor="booklet-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={<UploadFile />}
                      sx={{
                        borderRadius: 999,
                        justifySelf: "flex-end",
                      }}
                    >
                      {bookletFile ? "Replace Document" : "Upload Document"}
                    </Button>
                  </label>
                </>
              )}
            </Stack>
          </CardContent>
        </Card>
      )}

      {activeStep === 1 && (
        <StepOneScreen
          company={company}
          NextStep={NextStep}
          rfpFile={rfpFile}
          setRfpFile={setRfpFile}
          uploadCount={uploadCount}
          setUploadCount={setUploadCount}
          additionalInfoSections={additionalInfoSections}
          setAdditionalInfoSections={setAdditionalInfoSections}
          resummarizeCount={resummarizeCount}
          onResummarize={handleResummarize}
          apiResponse={apiResponse}
          isLoading={isLoading}
          insuranceType={insuranceType}
          error={error}
          BASE_URL={BASE_URL}
        />
      )}
      {activeStep === 2 && (
        <StepTwoScreen
          NextStep={NextStep}
          apiResponse={apiResponse}
          BASE_URL={BASE_URL}
          rfpFile={rfpFile}
        />
      )}

      {activeStep === 3 && (isLoading || CTApiResponse) && (
        <StepThreeScreen
          NextStep={NextStep}
          bookletFile={bookletFile}
          apiResponse={CTApiResponse}
          isLoading={isLoading}
          error={error}
          BASE_URL={BASE_URL}
        />
      )}
      {activeStep === 4 && <StepFourScreen ToHome={ToHome} />}
    </>
  );
};

export default Evaluation;
